import { INTERNAL_ROLES } from "../../../utils/Roles";
import userHasAccess from "../../../utils/userHasAccess";
import { RECURRING } from "../../dashboard/clients/enums/billingPeriodTypes";

export const canViewActivationStatus = (clientBillingPeriodType, isMintEnabledResponse) => {
    return userHasAccess(INTERNAL_ROLES, true) && clientBillingPeriodType === RECURRING.value && isMintEnabledResponse;
};



// WEBPACK FOOTER //
// ./src/components/common/MemberActivation/memberActivationHelper.js